import { actions } from '@/translations/en/flow/actions'
import { actionStage } from '@/translations/en/flow/actionStage'
import { command } from '@/translations/en/flow/command'
import { controls } from '@/translations/en/flow/controls'
import { errors } from '@/translations/en/flow/errors'
import { form } from '@/translations/en/flow/form'
import { labels } from '@/translations/en/flow/labels'
import { manage } from '@/translations/en/flow/manage'
import { manageIndexes } from '@/translations/en/flow/manageIndexes'
import { matrix } from '@/translations/en/flow/matrix'
import { modals } from '@/translations/en/flow/modals'
import { options } from '@/translations/en/flow/options'
import { packages } from '@/translations/en/flow/packages'
import { properties } from '@/translations/en/flow/properties'
import { rules } from '@/translations/en/flow/rules'
import { signatures } from '@/translations/en/flow/signatures'
import { status } from '@/translations/en/flow/status'
import { table } from '@/translations/en/flow/table'
import { tabs } from '@/translations/en/flow/tabs'

export const flow = {
  selectOptions: 'Option',
  addNewNode: 'Add new configuration template block',
  addNewNodePara:
    'Add a new step (node) to the configuration template editor. A node is the basic unit of configuration template where you can define options, rules, and dependencies.',
  label: 'Label',
  edit: 'Edit',
  displayEdit: 'Display form',
  code: 'Code',
  description: 'Option description',
  startAt: 'Valid from',
  expiresAt: 'Valid until',
  integrationCode: 'Integration code',
  calendarPlaceholder: 'Select date range',
  startAtPlaceholder: 'Valid from (YYYY-MM-DD)',
  expiresAtPlaceholder: 'Valid until (YYYY-MM-DD)',
  manageStep: 'Manage stages',
  addNewStep: 'Add new stage',
  assignStep: 'Assign stage to current step',
  currentStageMissing: 'This step is not assigned to a stage yet',
  changeStage: 'Change stage',
  assignStepDesc:
    'Choose the stage that should own this step. More actions will appear after assignment.',
  addNewStepDesc:
    'Create a new stage for the current configuration template and continue assigning steps.',
  deleteStep: 'Delete step',
  deleteStepDesc:
    'Deleting this step will permanently remove all dependencies and take it out of view. This action cannot be undone.',
  deleteStepTitle: 'Are you sure?',
  deleteStepWarning:
    'This action is irreversible. Once executed, the step will be deleted.',
  save: 'Save',
  noOptions: 'No options',
  addOption: 'Add option',
  deleteOption: 'Delete option',
  deletedOptionSuccess: 'Option deleted successfully',
  groups: 'Groups',
  groupsPreview: 'Preview possible group associations',
  groupsNotAvailable:
    'No available groups. Create a new group to be able to assign it.',
  groupAdd: 'Add group',
  cancel: 'Cancel',
  publishConfirm:
    'Are you sure you want to publish this configuration template?',
  publishDesc:
    'Publishing will make the configuration template visible on the connected site. Previous similar configuration templates will be archived.',
  publishDescription: 'Publish this configuration template.',
  publishDisabledDescription:
    'The initial configuration cannot contain conflicts. Check the configured options and rules before publishing.',
  publishSuccess: 'Configuration template published successfully',
  removeConnection: 'Connection removed',
  statusTitle: 'Status',
  productIndex: 'Product index',
  inputType: 'Option type',
  integrationParameterUsed: 'This integration parameter is already used.',
  integrationParameterFilterUsed: 'Used',
  integrationParameterFilterUnused: 'Unused',
  integrationParameterAllowedTypes: 'Allowed types',
  integrationParameterValues: 'Values',
  integrationParameterNoValues: 'No values',
  integrationValue: 'Integration value',
  selectValue: 'Select a value',
  noIntegrationParameters: 'No integration parameters found.',
  refreshIntegrationParameters: 'Refresh Impuls features',
  refreshIntegrationParametersTooltip:
    'Fetch the latest Impuls features from the system.',
  integrationStatusNotIntegrated: 'The step has no assigned integration code.',
  integrationStatusUnknownCode:
    'Unknown integration code - it may have changed in Impuls.',
  signatureElement: 'Product signature',
  indexSuccess: 'Index updated successfully',
  stepLabel: 'Step',
  optionLabel: 'Option',
  editIndex: 'Edit product index',
  manageIndexesDesc: 'Manage and edit indexes',
  editFormOpts: 'Edit form options',
  displayFormOpts: 'Display form options',
  exampleFor: 'Example for',
  treePropertySave: 'Save visibility properties',
  treeRestoreProperties: 'Restore original properties',
  confirmComponentTitle: 'Confirm dependent step option change',
  confirmComponent:
    'Changing this option will affect dependent steps. Please review the changes before proceeding.',
  confirmChangeComponentTitle: 'Confirm dependent step change',
  confirmChangeComponentDescription:
    'Changing this setting may affect existing connections. Do you want to continue?',
  signatureSegment: 'Signature',
  requiresSignatureSegment: 'Does it require a segment signature?',
  confirmDeleteSignatureFromOptionsTitle: 'Changing the signature requirement',
  confirmDeleteSignatureFromOptions:
    'This change will remove the signature from all options where it is currently assigned',
  confirmDeleteOptionsOnInputTypeChangeTitle: 'Changing the input type',
  confirmDeleteOptionsOnInputTypeChange:
    'This change will delete all existing options for this step. Do you want to continue?',
  chooseIndexes: 'Choose product indexes',
  indexSelected: 'Index selected {index}',
  indexDetails: 'Index details',
  indexIdentif: 'Index Identifier',
  closeDatils: 'Close details',
  chooseIndex: 'Choose index',
  showDetails: 'Show details',
  expandAll: 'Expand all',
  expandOneDeep: 'Expand one level',
  breadcrumbsTitle: 'Configuration template',
  breadcrumbsDesc: 'Current configuration template details',
  duplicate: 'Copy',
  allFlowsCount: 'All configuration templates {count}',
  flowsCount: 'Configuration templates {count}',
  example: {
    podwozieWielkie: 'Large chassis',
    podwozieMale: 'Small chassis',
    listwaZabezpieczajaca: 'Protective strip',
    kontener: 'Container',
    uchwyty: 'Mounting handles',
    color1: 'Green',
    color2: 'Blue',
  },

  notifications: {
    nodeDeleted: 'Step deleted successfully',
  },
  index: 'Index',
  componentStep: 'Dependent step',
  status: status,
  options: options,
  packages: packages,
  tabs: tabs,
  command: command,
  actions: actions,
  form: form,
  errors: errors,
  modals: modals,
  table: table,
  actionStage: actionStage,
  manageIndexes: manageIndexes,
  rules: rules,
  matrix: matrix,
  manage: manage,
  properties: properties,
  signatures: signatures,
  controls: controls,
  labels: labels,
}
